import { useState } from "react";
import { Link } from "react-router-dom";
import { BookOpen, Clock, Users, Star, ArrowRight, Play } from "lucide-react";
import Navbar from "./Navbar";

const lessons = [
  {
    id: "beginner1",
    title: "Hangul Basics",
    description: "Master the Korean alphabet from vowels to consonants",
    duration: "45 min",
    difficulty: "Beginner",
    icon: "🔤",
    topics: ["Basic Vowels", "Basic Consonants", "Syllable Formation"],
    isCompleted: false,
    isNext: true
  },
  {
    id: "beginner2",
    title: "Essential Greetings",
    description: "Learn polite greetings and basic conversation starters",
    duration: "30 min",
    difficulty: "Beginner",
    icon: "👋",
    topics: ["안녕하세요", "감사합니다", "죄송합니다"],
    isCompleted: false,
    isNext: false
  },
  {
    id: "beginner3",
    title: "Self-Introduction",
    description: "Introduce yourself confidently in Korean",
    duration: "35 min",
    difficulty: "Beginner",
    icon: "🙋‍♂️",
    topics: ["이름", "나이", "직업", "+1 more"],
    isCompleted: false,
    isNext: false
  },
  {
    id: "beginner4",
    title: "Numbers & Counting",
    description: "Master Korean numbers and counting systems",
    duration: "40 min",
    difficulty: "Beginner",
    icon: "🔢",
    topics: ["Native Numbers", "Sino-Korean Numbers", "Counting Objects"],
    isCompleted: false,
    isNext: false
  },
  {
    id: "beginner5",
    title: "Family & Relationships",
    description: "Learn family terms and relationship vocabulary",
    duration: "50 min",
    difficulty: "Beginner",
    icon: "👨‍👩‍👧‍👦",
    topics: ["가족", "부모님", "형제자매"],
    isCompleted: false,
    isNext: false
  },
  {
    id: "beginner6",
    title: "Daily Routines",
    description: "Describe your daily activities in Korean",
    duration: "45 min",
    difficulty: "Beginner",
    icon: "🌅",
    topics: ["기상", "식사", "일과"],
    isCompleted: false,
    isNext: false
  },
  {
    id: "beginner7",
    title: "Food & Dining",
    description: "Order food and discuss Korean cuisine",
    duration: "55 min",
    difficulty: "Beginner",
    icon: "🍜",
    topics: ["한국 음식", "주문하기", "맛 표현"],
    isCompleted: false,
    isNext: false
  },
  {
    id: "beginner8",
    title: "Shopping & Money",
    description: "Navigate shopping situations and handle money",
    duration: "40 min",
    difficulty: "Beginner",
    icon: "🛍️",
    topics: ["쇼핑", "가격", "결제"],
    isCompleted: false,
    isNext: false
  },
  {
    id: "beginner9",
    title: "Time & Dates",
    description: "Tell time and discuss dates in Korean",
    duration: "35 min",
    difficulty: "Beginner",
    icon: "📅",
    topics: ["시간", "날짜", "요일"],
    isCompleted: false,
    isNext: false
  },
  {
    id: "beginner12",
    title: "Weather & Seasons",
    description: "Discuss weather and seasonal activities",
    duration: "30 min",
    difficulty: "Beginner",
    icon: "🌤️",
    topics: ["날씨", "계절", "활동"],
    isCompleted: false,
    isNext: false
  },
  {
    id: "beginner10",
    title: "Colors & Descriptions",
    description: "Learn colors and descriptive vocabulary",
    duration: "35 min",
    difficulty: "Beginner",
    icon: "🎨",
    topics: ["색깔", "형용사", "묘사"],
    isCompleted: false,
    isNext: false
  },
  {
    id: "beginner11",
    title: "Transportation",
    description: "Navigate Korean transportation systems",
    duration: "40 min",
    difficulty: "Beginner",
    icon: "🚇",
    topics: ["지하철", "버스", "택시"],
    isCompleted: false,
    isNext: false
  },
  {
    id: "intermediate1",
    title: "Intermediate Conversation",
    description: "Build confidence in longer conversations",
    duration: "60 min",
    difficulty: "Intermediate",
    icon: "💬",
    topics: ["대화 연습", "문법", "표현"],
    isCompleted: false,
    isNext: false
  },
  {
    id: "intermediate2",
    title: "Business Korean",
    description: "Professional Korean for workplace situations",
    duration: "65 min",
    difficulty: "Intermediate",
    icon: "💼",
    topics: ["업무 용어", "이메일", "회의"],
    isCompleted: false,
    isNext: false
  },
  {
    id: "intermediate7",
    title: "Travel & Tourism",
    description: "Essential Korean for travelers",
    duration: "50 min",
    difficulty: "Intermediate",
    icon: "✈️",
    topics: ["여행", "호텔", "관광"],
    isCompleted: false,
    isNext: false
  },
  {
    id: "intermediate8",
    title: "Health & Medical",
    description: "Medical vocabulary and health conversations",
    duration: "55 min",
    difficulty: "Intermediate",
    icon: "🏥",
    topics: ["병원", "증상", "치료"],
    isCompleted: false,
    isNext: false
  },
  {
    id: "intermediate9",
    title: "Technology & Internet",
    description: "Modern tech vocabulary and digital communication",
    duration: "45 min",
    difficulty: "Intermediate",
    icon: "💻",
    topics: ["컴퓨터", "인터넷", "스마트폰"],
    isCompleted: false,
    isNext: false
  },
  {
    id: "advanced1",
    title: "Advanced Grammar",
    description: "Master complex Korean grammar structures",
    duration: "70 min",
    difficulty: "Advanced",
    icon: "📚",
    topics: ["고급 문법", "복합문", "문체"],
    isCompleted: false,
    isNext: false
  },
  {
    id: "advanced6",
    title: "Korean Literature",
    description: "Explore Korean literature and cultural expressions",
    duration: "75 min",
    difficulty: "Advanced",
    icon: "📖",
    topics: ["문학", "시", "소설"],
    isCompleted: false,
    isNext: false
  },
  {
    id: "advanced7",
    title: "Academic Korean",
    description: "Formal academic writing and presentations",
    duration: "80 min",
    difficulty: "Advanced",
    icon: "🎓",
    topics: ["학술", "논문", "발표"],
    isCompleted: false,
    isNext: false
  },
  {
    id: "advanced8",
    title: "Korean Media & News",
    description: "Understand Korean news and media language",
    duration: "65 min",
    difficulty: "Advanced",
    icon: "📺",
    topics: ["뉴스", "미디어", "보도"],
    isCompleted: false,
    isNext: false
  },
  {
    id: "advanced5",
    title: "Cultural Context",
    description: "Understand Korean culture through language",
    duration: "75 min",
    difficulty: "Advanced",
    icon: "🏛️",
    topics: ["문화적 맥락", "관용어", "전통"],
    isCompleted: false,
    isNext: false
  }
];

function LessonMenu() {
  const [selectedLevel, setSelectedLevel] = useState("All");
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const levels = ["All", "Beginner", "Intermediate", "Advanced"];
  
  const filteredLessons = selectedLevel === "All" 
    ? lessons 
    : lessons.filter(lesson => lesson.difficulty === selectedLevel);

  const completedCount = lessons.filter(lesson => lesson.isCompleted).length;
  const totalLessons = lessons.length;
  const progressPercentage = (completedCount / totalLessons) * 100;

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-100 to-red-100">
        {/* Header Section */}
        <div className="bg-gradient-to-r from-amber-100 to-orange-100 shadow-2xl border-b-4 border-red-200">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-16">
            <div className="text-center">
              <div className="flex flex-col sm:flex-row items-center justify-center mb-6 sm:mb-8">
                <div className="relative">
                  <div className="absolute -inset-4 bg-gradient-to-r from-red-500 to-orange-500 rounded-full blur-lg opacity-30 animate-pulse"></div>
                  <img
                    src="/korlish.png"
                    alt="Korlish Logo"
                    className="h-16 w-16 sm:h-20 sm:w-20 rounded-full shadow-2xl ring-4 ring-white relative z-10"
                  />
                  <div className="absolute -top-2 -right-2 bg-red-600 text-white text-sm font-bold px-3 py-1 rounded-full animate-bounce">
                    🇰🇷
                  </div>
                </div>
                <div className="sm:ml-6 mt-4 sm:mt-0">
                  <h1 className="text-3xl sm:text-5xl font-black text-gray-900 mb-2">Korean Learning Journey</h1>
                  <p className="text-lg sm:text-2xl text-red-700 font-black">한국어 학습 여정</p>
                  <p className="text-sm sm:text-lg text-gray-600 font-semibold">(Korean Learning Journey)</p>
                </div>
              </div>
              
              <p className="text-xl text-gray-800 max-w-4xl mx-auto leading-relaxed font-semibold mb-8">
                Master Korean step by step with our comprehensive curriculum. From Hangul basics to advanced business Korean - your path to fluency starts here.
              </p>

              {/* Progress Bar */}
              <div className="max-w-2xl mx-auto mb-8">
                <div className="flex justify-between items-center mb-4">
                  <span className="text-lg font-bold text-gray-800">Your Progress</span>
                  <span className="text-lg font-bold text-red-700">{completedCount}/{totalLessons} lessons</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-4 shadow-inner">
                  <div 
                    className="h-4 rounded-full bg-gradient-to-r from-red-500 to-orange-500 shadow-lg transition-all duration-500"
                    style={{ width: `${progressPercentage}%` }}
                  ></div>
                </div>
                <p className="text-center text-sm text-gray-600 mt-2 font-semibold">
                  {Math.round(progressPercentage)}% Complete
                </p>
              </div>

              {/* Level Filter */}
              <div className="flex flex-wrap justify-center gap-4 mb-8">
                {levels.map((level) => (
                  <button
                    key={level}
                    onClick={() => setSelectedLevel(level)}
                    className={`px-8 py-4 rounded-2xl font-bold text-lg transition-all duration-300 transform hover:scale-105 shadow-lg ${
                      selectedLevel === level
                        ? "bg-gradient-to-r from-red-600 to-orange-600 text-white shadow-xl"
                        : "bg-white text-gray-700 hover:bg-red-50 border-2 border-red-200 hover:border-red-400"
                    }`}
                  >
                    {level}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Lessons Grid */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
            {filteredLessons.map((lesson) => (
              <Link
                key={lesson.id}
                to={`/lesson/${lesson.id}`}
                className="group bg-white rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border-4 border-red-200 hover:border-red-400 overflow-hidden flex flex-col h-full"
              >
                {/* Lesson Header */}
                <div className="relative p-6 bg-gradient-to-br from-red-50 to-orange-50">
                  <div className="flex items-center justify-between mb-4">
                    <div className="text-4xl">{lesson.icon}</div>
                    {lesson.isNext && (
                      <div className="bg-red-600 text-white px-3 py-1 rounded-full text-sm font-bold flex items-center">
                        <Play className="w-4 h-4 mr-1" />
                        Next
                      </div>
                    )}
                  </div>
                  <h3 className="text-2xl font-black text-gray-900 mb-2 group-hover:text-red-700 transition-colors duration-300">
                    {lesson.title}
                  </h3>
                  <p className="text-gray-700 leading-relaxed font-medium">
                    {lesson.description}
                  </p>
                </div>

                {/* Lesson Details */}
                <div className="p-6 flex-1 flex flex-col">
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center text-gray-600">
                      <Clock className="w-5 h-5 mr-2" />
                      <span className="font-semibold">{lesson.duration}</span>
                    </div>
                    <span className={`px-3 py-1 rounded-full text-sm font-bold ${
                      lesson.difficulty === "Beginner" 
                        ? "bg-green-100 text-green-800" 
                        : lesson.difficulty === "Intermediate"
                        ? "bg-orange-100 text-orange-800"
                        : "bg-red-100 text-red-800"
                    }`}>
                      {lesson.difficulty}
                    </span>
                  </div>

                  <div className="mb-6">
                    <h4 className="text-lg font-bold text-gray-800 mb-3">What you'll learn:</h4>
                    <div className="space-y-2">
                      {lesson.topics.map((topic, index) => (
                        <div key={index} className="flex items-center text-gray-700">
                          <div className="w-2 h-2 bg-red-500 rounded-full mr-3"></div>
                          <span className="font-medium">{topic}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Action Button */}
                  <div className="mt-auto">
                    <div className="bg-gradient-to-r from-red-600 to-orange-600 text-white px-6 py-4 rounded-2xl font-bold text-center group-hover:from-red-700 group-hover:to-orange-700 transition-all duration-300 shadow-lg hover:shadow-xl transform group-hover:scale-105 flex items-center justify-center">
                      <span>Start Learning</span>
                      <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {filteredLessons.length === 0 && (
            <div className="text-center py-16">
              <div className="bg-white rounded-3xl shadow-xl p-12 border-4 border-red-200 max-w-2xl mx-auto">
                <div className="text-6xl mb-6">🔍</div>
                <h3 className="text-3xl font-black text-gray-900 mb-4">No lessons found</h3>
                <p className="text-xl text-gray-700 mb-8 font-semibold">
                  Try selecting a different difficulty level to see more lessons.
                </p>
                <button
                  onClick={() => setSelectedLevel("All")}
                  className="bg-gradient-to-r from-red-600 to-orange-600 text-white px-8 py-4 rounded-2xl font-bold hover:from-red-700 hover:to-orange-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
                >
                  Show All Lessons
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default LessonMenu;